import {
    FunctionField,
    ListContextProvider,
    TextField,
    useList,
    useRecordContext,
    useTranslate,
} from "react-admin";
import DamageReportIcon from "@mui/icons-material/Report";
import { RaDateField } from "shared/src/components/fields/Ra/RaDateField";
import { Box, Button, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useInfiniteScroll } from "shared/src/hooks/useInfiniteScroll";
import { DatagridWithHistory } from "shared/src/components/DatagridWithHistory";

export const DamageReports = ({ lastRentalItem }) => {
    const record = useRecordContext();
    const translate = useTranslate();
    const [damageReportLink, setDamageReportLink] = useState(
        `#/damageReports/create?sku=${record?.id}`
    );

    const { data, isPending, isFetchingNextPage, observerRef } = useInfiniteScroll(
        "damageReports",
        {
            filter: { sku: record?.id },
            pagination: { page: 1, perPage: 25 },
            sort: { field: "id", order: "DESC" },
        },
        {
            enabled: !!record?.id,
        }
    );

    const listContext = useList({ data, resource: "damageReports" });

    useEffect(() => {
        if (lastRentalItem) {
            const lastRental = lastRentalItem?._embedded?.rental?.data || null;
            const selectedRenter = lastRental?.actualRentalProcess?.renter?.id || null;
            const selectedRental =
                lastRentalItem?.returnedDate &&
                dayjs().diff(lastRentalItem?.returnedDate, "days") <= 7
                    ? lastRental?.id
                    : null;
            setDamageReportLink(
                `#/damageReports/create?sku=${record.id}` +
                    (selectedRenter ? `&renter=${selectedRenter}` : "") +
                    (selectedRental ? `&rental=${selectedRental}` : "")
            );
        }
    }, [lastRentalItem, record?.id]);

    if (isPending) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box>
            <Box
                sx={{
                    width: 330,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    my: 2,
                }}
            >
                <Button
                    variant="text"
                    startIcon={<DamageReportIcon fontSize="large" />}
                    size="small"
                    title={translate("equip.addDamageReport")}
                    aria-label={translate("equip.addDamageReport")}
                    href={damageReportLink}
                >
                    {translate("equip.addDamageReport")}
                </Button>
            </Box>
            <ListContextProvider value={listContext}>
                <DatagridWithHistory
                    bulkActionButtons={false}
                    rowClick={(id, _, rowRecord) => {
                        return `/damageReports/${rowRecord.id}/show`;
                    }}
                >
                    <TextField label="equip.title" source="title" />
                    <RaDateField label="equip.date" source="date" />
                    <TextField label="equip.sku" source="sku.labelNumber" />
                    <TextField label="equip.responsibleUser" source="responsibleUser.email" />
                    <FunctionField
                        label="equip.status"
                        render={(rowRecord) =>
                            translate(`equip.damageReportStatus_${rowRecord.status}`)
                        }
                    />
                </DatagridWithHistory>
            </ListContextProvider>
            <Box ref={observerRef} sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                {isFetchingNextPage && <CircularProgress size={24} />}
            </Box>
        </Box>
    );
};
